<template lang="pug">
</template>
<script>
import { useAppStoreOpener } from '@/composables/signup/useAppStoreOpener'
const appStoreOpener = useAppStoreOpener()

export default {
  created () {
    if (!appStoreOpener.openAppStore()) {
      this.$router.push({ name: 'pageNotFound' })
    }
  },
}
</script>

